import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { NAV_ROUTES } from '../routes.js';
import styles from './Navbar.module.css';

export default function Navbar() {
  return (
    <nav className={styles.nav}>
      <div className={styles.inner}>
        <Link to="/" className={styles.brand}>
          <span className={styles.brandIcon}>⚙️</span>
          <span className={styles.brandName}>Admin Dashboard</span>
        </Link>
        <div className={styles.links}>
          {NAV_ROUTES.map(({ path, name, icon }) => (
            <NavLink
              key={path}
              to={path}
              end={path === '/'}
              className={({ isActive }) =>
                `${styles.link} ${isActive ? styles.active : ''}`
              }
            >
              <span className={styles.linkIcon}>{icon}</span>
              {name}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}
